import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'components/AppRequest';
import withRouter from 'components/components/common/withRouter';
import { connect } from 'react-redux';
import { updateRegisterFields, setUserLogged } from 'components/actions/authActions';
import { GOOGLE } from 'components/common/constants/authConstants';
import SignUpRedirectHelper from './utils/SignUpRedirectHelper';
import LocalStorageHelper from 'components/common/helpers/LocalStorageHelper';
import {
  createErrorNotification
} from 'components/actions/serviceActions';
import TransHelper from 'components/common/translations/TransHelper';
import originAxios from 'axios';

class GoogleAuth extends Component {

  transNotify = (key) => {
    return TransHelper.translate(this.props.locale, 'content.notifications.google.' + key);
  }
  // in google named as 'Identity Toolkit API'
  componentDidMount() {
    gapi.load('auth2', () => {
      this.auth2 = gapi.auth2.init({
        client_id: '1032970694588-n38d0fan51kfdfsar88d7ad67mqeao48.apps.googleusercontent.com',
        cookiepolicy: 'single_host_origin',
      });
      this.attachSignin(document.getElementById('googleCtmButton'));
    });
  }

  successCallback = (googleUser) => {
    var profile = googleUser.getBasicProfile();
    var id_token = googleUser.getAuthResponse().id_token;
    var customerData = {
      token: id_token,
      profile_id: profile.getId(),
      name: profile.getName(),
      email: profile.getEmail(),
      type: GOOGLE
    };
    this.props.updateRegisterFields(customerData);

    var params = {
      data: {
        token: id_token,
        profile_id: profile.getId(),
        type: GOOGLE,
        customer: {
          name: profile.getName(),
          email: profile.getEmail(),
        }
      }
    }

    if (this.props.isRegister) {
      var helper = new SignUpRedirectHelper(customerData);
      axios.post('/pwa/registration/check-social-account', params)
        .then(response => {
          originAxios.post('/set-logged');
          helper.accountCreatedAlready = true;
          LocalStorageHelper.saveToken(response.data.token);
          this.props.setUserLogged(response.data);
          TransHelper.redirect(this.props, helper.getRedirectPath());
        })
        .catch(err => {
          TransHelper.redirect(this.props, helper.getRedirectPath());
          console.log("err", err.response)
          console.log("AUTH FAIL")
        });

    } else {
      //login request
      axios.post('/pwa/security/login-via-google', params)
        .then(response => {
          originAxios.post('/set-logged');
          LocalStorageHelper.saveToken(response.data.token);
          this.props.setUserLogged(response.data);
          TransHelper.redirect(this.props, 'routes.url.dashboard');
        })
        .catch(err => {
          console.log(err)
          this.props.createErrorNotification({
            title: this.transNotify('error'),
            message: err.response.data.error
          });
        });
    }
  }

  attachSignin = (element) => {
    this.auth2.attachClickHandler(
      element,
      {},
      this.successCallback.bind(this),
      function (error) {
        console.log("error google", (JSON.stringify(error, undefined, 2)));
      }
    );
  }

  clickLoginAction = (e) => {
    e.preventDefault();
  }

  render() {
    if (this.props.isRegister) {
      return (
        <a
          onClick={(e) => e.preventDefault()}
          id="googleCtmButton"
          href=""
          className="button button--expand button--outline button--icon button--google"
        >
          <FontAwesomeIcon
            icon={['fab', 'google']}
            size="lg"
          />
          <span>Google</span>
        </a>
      );
    } else {
      return (
        <a
          id="googleCtmButton"
          onClick={this.clickLoginAction}
          href=""
        >Google</a>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    { updateRegisterFields, setUserLogged, createErrorNotification }
  )(GoogleAuth));
